import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from './environments/environment';

registerLicense(environment.syncFusionConfig.apiKey);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
